import AppApi from './API'
import axiosInstance from './AxiosInstance'
// @ts-ignore
import W from 'wialonjs-api'

/**
 * Wialon API integration endpoints using RTK Query.
 * This file configures endpoints for interacting with the Wialon GPS tracking service,
 * handling vehicle location data and authentication.
 */
export const wialonEndPoints = AppApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Endpoint to fetch Wialon session ID (SID) token.
     * This token is required for authenticating subsequent requests to the Wialon API.
     */
    fetchSIDToken: builder.query({
      queryFn: async () => {
        try {
          const response = await axiosInstance.get(`/thiredparty/wialan/return-eid`)
          return { data: response.data }
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' }
        }
      },
      providesTags: ['wialon'],
    }),

    fetchSIDTokenPublic: builder.query({
      queryFn: async (securityKey: string) => {
        try {
          const response = await axiosInstance.post(
            `/thiredparty/v2/wialan/return-eid`,
            {
              securityKey: securityKey
            }
          )
    
          return { data: response.data }
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' }
        }
      },
      providesTags: ['wialon'],
    }),

    /**
     * Endpoint to fetch GPS vehicle details from Wialon API.
     * @param itemIdsArray - Array of vehicle IDs to fetch details for
     * @param sID - Wialon session ID for authentication
     * Returns vehicle location and status information for the specified vehicles.
     */
    getGPSVehicleDetails: builder.query({
      queryFn: async ({ itemIdsArray, sID}: { itemIdsArray: string[], sID: string,}) => {
        try {
          const result = await new Promise((resolve, reject) => {
            new W.Request('https://hst-api.wialon.com').api(
              'core/search_items',
              {
                params: {
                  spec: {
                    itemsType: 'avl_unit',
                    propName: 'sys_id',
                    propValueMask: itemIdsArray,
                    sortType: 'sys_id',
                  },
                  force: 1,
                  flags: 1025,
                  from: 0,
                  to: 0,
                },
                sid: sID,
              },
              function (result: any) {
                if (result) {
                  resolve(result?.items)
                } else {
                  reject('Failed to fetch vehicle details')
                }
              }
            )
          })
          return { data: result as any }
        } catch (error) {
          return { error: (error as any).response?.data || 'Something went wrong' }
        }
      },
      providesTags: (result) => [
        'wialon',
        { type: 'wialon', id: 'LIST' },
        ...(result?.data
          ? result.data.map((item: any) => ({ type: 'wialon', id: item.id }))
          : [])
      ],
      keepUnusedDataFor: 0,
    }),
  }),
})

export const { useFetchSIDTokenQuery, useGetGPSVehicleDetailsQuery, useFetchSIDTokenPublicQuery } = wialonEndPoints
